export default "__VITE_ASSET__CfOj76WG__"